var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevisionMaterialBgShape({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 368.32,
    height: 345.309,
    viewBox: "0 0 368.32 345.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fdd06b;opacity:0.2;}.c{clip-path:url(#a);}.d{fill:url(#b);}.e{fill:url(#c);}.f{clip-path:url(#d);}.am,.an,.ao,.ap,.ar,.au,.az,.ba,.g{mix-blend-mode:color-burn;isolation:isolate;}.g{fill:url(#e);}.h{fill:url(#f);}.i{fill:url(#g);}.j{fill:url(#h);}.k{fill:url(#i);}.l{fill:url(#j);}.m{fill:url(#k);}.n{fill:url(#l);}.o{fill:url(#m);}.p{fill:url(#n);}.q{fill:url(#o);}.r{fill:url(#p);}.s{fill:url(#q);}.t{fill:url(#r);}.u{fill:url(#s);}.v{fill:url(#t);}.w{fill:url(#u);}.x{fill:url(#v);}.y{fill:url(#w);}.z{fill:url(#x);}.aa{fill:url(#y);}.ab{fill:url(#z);}.ac{fill:url(#aa);}.ad{opacity:0.34;fill:url(#ab);}.ae{fill:url(#ac);}.af{fill:url(#ad);}.ag{fill:url(#ae);}.ah{fill:url(#af);}.ai{fill:url(#ag);}.aj{fill:url(#ah);}.ak{fill:url(#ai);}.al{clip-path:url(#aj);}.am{fill:url(#ak);}.an{fill:url(#al);}.ao{fill:url(#am);}.ap{fill:url(#an);}.aq{clip-path:url(#ao);}.ar{fill:url(#ap);}.as{fill:url(#aq);}.at{clip-path:url(#ar);}.au{fill:url(#as);}.av{fill:url(#at);}.aw{fill:url(#au);}.ax{fill:url(#av);}.ay{clip-path:url(#aw);}.az{fill:url(#ax);}.ba{fill:url(#ay);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 264.656,
    height: 264.656
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0188c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 121.764,
    y1: 92.299,
    x2: 120.486,
    y2: 92.299,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1072.871,1019.54h0V943.219l29.869,19.08,29.869,19.08h0l29.869,19.08-29.869,19.08h0l-29.869,19.08-29.869,19.08Z",
    transform: "translate(-1072.871 -943.219)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 31.085,
    y1: 25.547,
    x2: 30.085,
    y2: 25.547,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424242"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 122.126,
    y1: 3.58,
    x2: 120.848,
    y2: 3.58,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fda626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdb1d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 61.84,
    y1: 3.377,
    x2: 60.563,
    y2: 3.377,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#239ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69d1fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 126.682,
    y1: 4.015,
    x2: 125.405,
    y2: 4.015,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a10052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7004e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 126.043,
    y1: 3.515,
    x2: 124.766,
    y2: 3.515,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b51f6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc226b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 125.405,
    y1: 3.015,
    x2: 124.127,
    y2: 3.015,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 126.319,
    y1: 95.865,
    x2: 125.042,
    y2: 95.865,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 125.681,
    y1: 95.363,
    x2: 124.403,
    y2: 95.363,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e96db8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc226b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 125.042,
    y1: 94.863,
    x2: 123.764,
    y2: 94.863,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd2b93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd226b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 124.403,
    y1: 3.798,
    x2: 123.125,
    y2: 3.798,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdae1d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 123.764,
    y1: 3.298,
    x2: 122.487,
    y2: 3.298,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd7f01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdc202"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 125.319,
    y1: 6.08,
    x2: 124.042,
    y2: 6.08,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 124.68,
    y1: 5.58,
    x2: 123.403,
    y2: 5.58,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 124.042,
    y1: 5.08,
    x2: 122.764,
    y2: 5.08,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 123.403,
    y1: 4.58,
    x2: 122.125,
    y2: 4.58,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 122.764,
    y1: 4.08,
    x2: 121.486,
    y2: 4.08,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 122.403,
    y1: 92.799,
    x2: 121.125,
    y2: 92.799,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02708a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0fa5dc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 85.527,
    y1: 64.807,
    x2: 84.249,
    y2: 64.807,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 121.125,
    y1: 91.799,
    x2: 119.848,
    y2: 91.799,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 121.405,
    y1: 6.146,
    x2: 120.127,
    y2: 6.146,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 62.841,
    y1: 3.459,
    x2: 61.882,
    y2: 3.459,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 182.04,
    y1: 138.254,
    x2: 180.762,
    y2: 138.254,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 127.042,
    y1: 94.685,
    x2: 125.764,
    y2: 94.685,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 183.219,
    y1: 2.934,
    x2: 181.941,
    y2: 2.934,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 120.766,
    y1: 0.413,
    x2: 119.488,
    y2: 0.413,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 120.403,
    y1: 98.211,
    x2: 119.125,
    y2: 98.211,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 123.764,
    y1: 3.298,
    x2: 122.487,
    y2: 3.298,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ae7b01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fda302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 245.851,
    y1: 5.367,
    x2: 244.573,
    y2: 5.367,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 177.405,
    y1: 134.625,
    x2: 176.127,
    y2: 134.625,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 291.462,
    y1: 221.336,
    x2: 290.184,
    y2: 221.336,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M953.417,791.173h0l52.348-33.44h0l39.749-25.392-13.576-8.672V667.443l44.009,28.113V712.9l34.513-22.047v66.88h0l26.174,16.72,25.123,16.049,18.5,11.818h0l8.724,5.574,8.445,5.394,17.729,11.326,52.348,33.44-52.348,33.44-52.348,33.44-52.348,33.44h0l-52.348-33.44h0l-18.224-11.641v14.146l-26.174-16.72,11.072-7.073-19.023-12.152h0l-52.348-33.44-52.348-33.44Z",
    transform: "translate(-901.069 -667.443)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 35.159,
    y1: 26.39,
    x2: 33.881,
    y2: 26.39,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 31.824,
    y1: 27.41,
    x2: 30.824,
    y2: 27.41,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1194.315,775.314V674.994l78.521,50.16Z",
    transform: "translate(-1194.315 -674.994)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 82.118,
    y1: 71.738,
    x2: 81.118,
    y2: 71.738,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 123.525,
    y1: 93.678,
    x2: 122.248,
    y2: 93.678,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M998.817,824.236v-66.88l52.348,33.44Z",
    transform: "translate(-998.817 -757.356)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 56.035,
    y1: 42.302,
    x2: 54.757,
    y2: 42.302,
    xlinkHref: "#al"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 189.661,
    y1: 5.695,
    x2: 188.383,
    y2: 5.695,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 178.881,
    y1: 135.778,
    x2: 177.604,
    y2: 135.778,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M976.616,1036.021V946.354l70.183,44.833Z",
    transform: "translate(-976.616 -946.354)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 47.957,
    y1: 36.113,
    x2: 46.68,
    y2: 36.113,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 132.794,
    y1: 100.651,
    x2: 131.516,
    y2: 100.651,
    xlinkHref: "#e"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-137.931)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-14707.445-10241h-361.623s96.553,48.847,97.746,137.43,65.563,124.5,125.166,123.3,138.711-41.9,138.711-41.9Z",
    transform: "translate(15206.999 10241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-14804.369-10241h-264.7s96.553,50.936,97.746,143.307,76.871,129.7,125.166,128.572,43.039-43.688,43.039-43.688Z",
    transform: "translate(15309.2 10314.406)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240.792)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1072.871,1019.54h0V943.219l29.869,19.08,29.869,19.08h0l29.869,19.08-29.869,19.08h0l-29.869,19.08-29.869,19.08Z",
    transform: "translate(-931.825 -806.068)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1083.748,904.726v66.88l-52.348-33.44Z",
    transform: "translate(-819.782 -798.497)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.046 137.151)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1020.3,1206.422V953.913l197.642,126.255Z",
    transform: "translate(-1086.104 -945.323)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1096.566,979.794l52.348-33.44v66.881Z",
    transform: "translate(-937.296 -806.684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M966.235,869.015h0V779.841l34.9,22.293,34.9,22.293h0l34.9,22.293-34.9,22.294h0l-34.9,22.293-34.9,22.293Z",
    transform: "translate(-754.616 -773.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1279.245,846.722V779.841l-52.348,33.44Z",
    transform: "translate(-1172.323 -773.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1226.9,821.469V888.35l52.348-33.441Z",
    transform: "translate(-1172.323 -782.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1279.245,929.978V863.1l-52.348,33.44Z",
    transform: "translate(-1172.323 -790.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1214.08,738.213v66.88l-52.348-33.44Z",
    transform: "translate(-1054.81 -765.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1161.732,846.722V779.841l52.348,33.44Z",
    transform: "translate(-1054.81 -773.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M1214.08,821.469V888.35l-52.348-33.441Z",
    transform: "translate(-1054.81 -782.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1161.732,929.978V863.1l52.348,33.44Z",
    transform: "translate(-1054.81 -790.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1214.08,904.726v66.88l-52.348-33.44Z",
    transform: "translate(-1054.81 -798.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1096.566,738.213v66.88l52.348-33.44Z",
    transform: "translate(-937.296 -765.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M1148.914,846.722V779.841l-52.348,33.44Z",
    transform: "translate(-937.296 -773.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M1096.566,821.469V888.35l52.348-33.441Z",
    transform: "translate(-937.296 -782.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M1148.914,929.978V863.1l-52.348,33.44Z",
    transform: "translate(-937.296 -790.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M1096.566,904.726v66.88l52.348-33.44Z",
    transform: "translate(-937.296 -798.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M1031.4,929.978V863.1l52.348,33.44Z",
    transform: "translate(-819.782 -790.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M1194.315,775.314V674.994l78.521,50.16Z",
    transform: "translate(-1139.741 -753.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M1031.4,1013.234v-66.88l52.348,33.44Z",
    transform: "translate(-819.782 -806.684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M1018.583,929.978V863.1l-52.348,33.44Z",
    transform: "translate(-702.269 -790.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1148.914,880.162l-52.348-33.44,52.348-33.44h0l52.348-33.44v66.88h0Z",
    transform: "translate(-989.644 -773.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M1117.328,867.041V821.469L1153,844.256Z",
    transform: "translate(-958.058 -782.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M1344.411,821.469V888.35l-52.348-33.441Z",
    transform: "translate(-1289.837 -782.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M1252.222,1015.287v-45L1217,992.787Z",
    transform: "translate(-1137.35 -811.392)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M966.235,904.726v66.88l52.348-33.44Z",
    transform: "translate(-702.269 -798.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M901.069,929.978V863.1l52.348,33.44Z",
    transform: "translate(-584.755 -790.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M1214.08,971.606v-66.88l-52.348,33.44Z",
    transform: "translate(-1054.81 -798.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M1210.591,949.472v33.44l-26.174-16.72Z",
    transform: "translate(-1069.544 -807.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M966.235,921.933V876.361l35.669,22.786Z",
    transform: "translate(-685.59 -792.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M921.831,959.788V932.467l21.385,13.66Z",
    transform: "translate(-591.232 -803.953)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M1110.3,1026.581V973.8l41.313,26.39Z",
    transform: "translate(-951.034 -812.083)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.226 -84.382)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "al",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1134.065,798.75v237.142L948.452,917.321Z",
    transform: "translate(-805.692 -693.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M1015.543,911.552v34.232L829.929,827.213,856.723,810.1Z",
    transform: "translate(-591.96 -695.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M1111.194,913.6V661.1L1308.835,787.35Z",
    transform: "translate(-1111.194 -666.194)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M1382.19,920.059v45.4L1136.018,808.2l35.535-22.7Z",
    transform: "translate(-1204.49 -690.664)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.574 -78.316)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "aq",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "M1213.773,799.789V703.165l75.629,48.313Z",
    transform: "translate(-1226.511 -680.535)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M998.817,824.236v-66.88l52.348,33.44Z",
    transform: "translate(-761.025 -769.51)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.792 -12.154)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "at",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M950.307,794.113V644.005L1067.8,719.059Z",
    transform: "translate(-976.481 -735.061)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M1316.022,796.833v-45l-35.222,22.5Z",
    transform: "translate(-1252.4 -768.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M954.414,844.556V798.984l35.669,22.786Z",
    transform: "translate(-664.273 -777.698)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M976.616,1036.021V946.354l70.183,44.833Z",
    transform: "translate(-738.824 -806.684)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.792 139.67)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ay",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "M956.034,1115.8V946.354l132.627,84.723Z",
    transform: "translate(-1001.945 -946.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ba",
    d: "M1020.3,1067.055v-60.4l47.278,30.2Z",
    transform: "translate(-1032.486 -958.214)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevisionMaterialBgShape);
export default __webpack_public_path__ + "static/media/revision-material-bg-shape.7d6c48dfa1efa005250313d9b77f88ad.svg";
export { ForwardRef as ReactComponent };